<template>
  <div class="settings">
    <shell>
      <div class="container m-auto">
        <div class="sm:w-full lg:w-1/2 pb-6 m-auto px-2">
          <h2 class="text-3xl font-bold pb-12">Account</h2>
          <div v-if="member" class="pb-8">
            <div v-if="isEmailVerified" class="bg-blue-lightest py-4 text-center mb-4">
              <p>Your email has been successfully verified!</p>
            </div>
            <div class="pb-6 text-xl font-bold">Member Information</div>

            <div class="pb-6">
              <h4 class="text-base font-bold pb-2">Email</h4>

              <div class="flex items-center pb-2">
                <p class="text-base font-mono">
                  {{member.email}}
                </p>
              </div>
              <div
                class="text-xs"
                v-if="member.email_verified === false">
                <span
                  v-if="!emailVerificationSent"
                  class="text-full-blue underline cursor-pointer"
                  @click="sendVerificationEmail()">Resend verification email</span>
                <span v-else>Please check your email</span>
              </div>
            </div>


            <div class="pb-6" v-if="isSubscribed">
              <h4 class="text-base pb-2">Phone Number</h4>
              <p class="mb-4 text-xs">*Currently only supporting US phone numbers.</p>
              <div v-if="member.phone_number">
                <div v-if="editPhoneNumber">
                  <form class="" @submit.prevent="addPhoneNumber">
                    <p class="text-red text-sm mb-4 leading-normal" v-if="phoneNumberError">{{phoneNumberError}}</p>
                    <div class="flex items-center">
                      <input
                        class="appearance-none mr-4 rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
                        @input="formatNumber( $event.target.value)"
                        :value="phoneNumber"
                        placeholder="Phone Number" />
                      <div class="text-full-blue text-xs underline mx-4 cursor-pointer" @click="editPhoneNumber = false">Cancel</div>
                      <t-button
                        type="submit"
                      >
                        Change
                      </t-button>
                    </div>
                  </form>
                </div>

                <div v-else>
                  <div class="flex items-center pb-2">
                    <p class="text-base font-mono">
                      {{displayNumber}}
                    </p>
                    <div class="text-full-blue text-xs underline ml-2 cursor-pointer" @click="editPhoneNumber = true">Edit</div>

                  </div>
                  <div
                    class="text-xs"
                    v-if="member.phone_number_verified === false">
                    <span
                      v-if="!textVerificationSent"
                      class="text-full-blue underline cursor-pointer"
                      @click="sendVerificationText()">Resend verification text</span>
                    <span v-else>Please check your text messages for a verification link</span>
                  </div>
                </div>
              </div>

              <div v-else>
                <form class="" @submit.prevent="addPhoneNumber">
                  <div>
                    <p class="text-red text-sm mb-4 leading-normal" v-if="phoneNumberError">{{phoneNumberError}}</p>
                    <div class="flex">
                      <input
                        class="appearance-none mr-4 rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"
                        @input="formatNumber( $event.target.value)"
                        :value="phoneNumber"
                        placeholder="Phone Number" />
                      <t-button
                        type="submit"
                      >
                        Add
                      </t-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>


            <div class="pb-6" v-else>
              <h4 class="text-base pb-2">Phone Number</h4>
              <div class="bg-full-blue text-white py-4 px-2 mb-4 text-sm rounded">
                <p><router-link  class="text-white" to="/subscribe">Subscribe</router-link> to connect your phone number</p>
              </div>
            </div>

            <div class="pb-6" v-if="isSubscribed && member.assigned_email">
              <h4 class="text-base pb-2">Receiver Email</h4>
              <p class="mb-4 text-xs">Emails sent to the address below will be saved in your Tap account.</p>
              <p class="mb-4 text-xs">If you despise the email assigned to you, please contact us at hello@tatatap.com and we will change it for you.</p>
              <div>
                <div class="flex items-center pb-2">
                  <p class="text-base font-mono">
                    Tap <{{member.assigned_email}}>
                  </p>
                  <span class="text-full-blue text-xs underline ml-2 cursor-pointer" @click="copyToClipboard">Copy</span>
                </div>

              </div>

            </div>


            <div>
              <router-link
                class="text-full-blue underline"
                to="/logout">Logout</router-link>
            </div>
          </div>

          <div v-if="member" class="pb-8">
            <div class="pb-6 text-xl font-bold">Subscription</div>
            <div v-if="isSubscribed">
              <p class="leading-normal mb-4 text-base">You are subscribed paying
                <strong>{{
                        ({year_basic: '$65 per year minus discounts',
                          month_basic: '$7 per month minus discounts'})[member.plan_name]
                        }}</strong>.</p>

              <p class="leading-normal mb-4 text-base">
                <router-link to="/subscribe">Manage subscription</router-link>
              </p>
            </div>
            <div v-else>
              <p class="leading-normal mb-4 text-base">
                <router-link to="/subscribe">Subscribe Now</router-link>
              </p>

            </div>
          </div>

          


          <div class="">
            <div class="pb-6 text-xl font-bold">Legal</div>
            <div class="pb-4">
              <a target="_blank" class="text-full-blue" href="https://www.tatatap.com/terms-of-service">Terms of Service</a>
            </div>
            <div class="pb-4">
              <a target="_blank" class="text-full-blue" href="https://www.tatatap.com/privacy-policy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </shell>
  </div>
</template>

<script>
 import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js';
 import Shell from '@/components/Shell'

 import {mapState, mapActions} from 'vuex';
 import api from '@/api';

 export default {
   components: { Shell},
   data () {
     return {
       phoneNumber: '',
       editPhoneNumber: false,
       textVerificationSent: false,
       emailVerificationSent: false,

       phoneNumberError: '',
       SERVER: process.env.VUE_APP_API_URL,
     }
   },
   computed: Object.assign(
     mapState({
       member: state => state.member,
       error: state => state.displayError
     }),
     {
       displayNumber() {
         if (!this.member || !this.member.phone_number) {
           return;
         }

         return parsePhoneNumberFromString(
           this.member ? this.member.phone_number ? this.member.phone_number : '' : '',
           'US')
           .formatNational()
       },

       isEmailVerified () {
         return this.$route.query.emailverified === 'true';
       },

       isSubscribed () {
         return ['alpha', 'year_basic', 'month_basic'].indexOf(this.member.plan_name) !== -1;
       }
   }),

   methods: {
     ...mapActions(['updateMemberPhoneNumber',
                    'resendMemberEmailVerification',
                    'resendMemberNumberVerification']),

     async addPhoneNumber () {
       const parsed = parsePhoneNumberFromString(this.phoneNumber, 'US');

       if (!parsed || !parsed.isValid()) {
         this.phoneNumberError = 'Enter a valid phone number.'
         return;
       }

       this.editPhoneNumber = false;

       await this.updateMemberPhoneNumber({phoneNumber: this.phoneNumber});
     },

     async sendVerificationEmail () {
       this.emailVerificationSent = true;
       await this.resendMemberEmailVerification()
     },

     async sendVerificationText () {
       this.textVerificationSent = true;
       await this.resendMemberNumberVerification()
     },


     formatNumber (number) {
       const res = new AsYouType('US').input(number);

       this.phoneNumber = res
     },

     copyToClipboard () {
       navigator.clipboard.writeText('Tap <' + this.member.assigned_email + '>')
       this.$toasted.show('Copied to clipboard', {duration: 2000, position: 'top-center', singleton: true, type: 'success'})
     },
   },

 };
</script>

